






























































































// 企业端pc模板
import JSEncrypt from "jsencrypt";
export default {
  name: "enterprise-enterpriseTemplate-pc",
  props: ["config"],
  data() {
    return {
      openEye: false,
      clock: false,
      time: 60,
      formTest: {
        phone: false,
        checkNum: false,
        password: false,
      },
      formData: {
        phone: "",
        checkNum: "",
        password: "",
      },
    };
  },
  computed: {
    next: function() {
      const flag =
        Object.keys((this as any).formData).every(
          (key) => (this as any).formData[key]
        ) &&
        Object.keys((this as any).formTest).every(
          (key) => !(this as any).formTest[key]
        );
      return flag;
    },
  },
  watch: {
    // formData: {
    //   handler(newCul: any) {
    //     console.log(newCul, "newCul");
    //     Object.keys(newCul).every((key) => {
    //       (this as any).test(key);
    //     });
    //   },
    //   deep: true,
    // },
  },
  methods: {
    limit(key: string) {
      const instance = this as any;
      if (key === "phone" && instance.formData[key].length > 11) {
        instance.formData[key] = instance.formData[key].slice(0, 11);
      }
    },
    test(key: string) {
      const instance = this as any;
      if (key === "password") {
        const passwordReg = /^[0-9A-Za-z]{6,16}$/;
        if (
          !instance.formData[key] ||
          !passwordReg.test(instance.formData[key])
        ) {
          instance.formTest[key] = true;
        } else {
          instance.formTest[key] = false;
        }
      }
      if (key === "phone") {
        const phoneReg = /^[1][0-9]{10}$/;
        if (!instance.formData[key] || !phoneReg.test(instance.formData[key])) {
          instance.formTest[key] = true;
        } else {
          instance.formTest[key] = false;
        }
      }
    },
    sendSms() {
      const instance = this as any;
      const phoneReg = /^[1][0-9]{10}$/;
      if (
        !(this as any).formData.phone ||
        !phoneReg.test(instance.formData.phone)
      ) {
        instance.formTest.phone = true;
        return;
      }
      (this as any).clock = true;
      (this as any).time = 60;
      const inter = setInterval(() => {
        (this as any).time--;
        if ((this as any).time <= 0) {
          clearInterval(inter);
          (this as any).clock = false;
        }
      }, 1000);
      const config = (this as any).config;
      const params = {
        businessType: 1,
        phone: (this as any).formData.phone,
        smsType: config.smsType,
        userType: config.userType,
      };
      // (this as any).$emit("send-sms", params);
      (this as any).$emit("send-sms", params);
    },
    encryptDeal(msg: string) {
      const publicKey =
        "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKbpotLkdWJlxvWuydKwQkryMb3m2mZrj8tizRUbwBW9Bnyu0syIXz+IkxP6Z76b4cEO2NyEq5yPcJdaBKynSVcCAwEAAQ==";

      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(publicKey);
      return encrypt.encrypt(msg);
    },
    resetPassword() {
      if (!(this as any).next) return;
      const instance = this as any;
      const config = (this as any).config;
      const params = {
        phone: (this as any).formData.phone,
        checkNum: (this as any).formData.checkNum,
        userType: config.userType,
        password: instance.encryptDeal((this as any).formData.password),
      };
      (this as any).$emit("reset-password", params);
    },
    goLogin() {
      (this as any).$emit("go-login");
    },
  },
};
